import { RowCrudStatus } from "../../common/types";
import { SignedEdition } from "../../../api/graphql";
import { LangStore } from "../../../store";
import { signedEditionDndaWorkflowStateDisplayId } from "../../signedEditionDndaWorkflowState/store/SignedEditionDndaWorkflowStateCommonStore";
import { signedEditionSadaicWorkflowStateDisplayId } from "../../signedEditionSadaicWorkflowState/store/SignedEditionSadaicWorkflowStateCommonStore";
import { musicalWorkDisplayId } from "../../musicalWork/store/MusicalWorkCommonStore";
import { diaDeCalendario } from "../../../common/calendarDate";
import {
  AssociatedDocumentSignedEditionValuesType,
  getAssociatedDocumentSignedEditionValues,
} from "../../associatedDocumentSignedEdition/store/AssociatedDocumentSignedEditionCommonStore";
import { FileCRUDType, fileCRUDInit } from "../../common/types";
import { formatBytes } from "../../../common/utils";
import {
  SignedEditionBlockchainCertValuesType,
  getSignedEditionBlockchainCertValues,
} from "../../signedEditionBlockchainCert/store/SignedEditionBlockchainCertCommonStore";

let uniqueCounter = 1;
export type SignedEditionValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  dndaState_transitions_: string[];
  __dndaState: string;
  showDndaState: { displayId: string; id: string } | null;
  sadaicState_transitions_: string[];
  __sadaicState: string;
  showSadaicState: { displayId: string; id: string } | null;
  __works: string[];
  showWorks: { displayId: string; id: string }[];
  publicationDate: string | null;
  dndaExpedienteNumber: string;
  showDndaDocuments: AssociatedDocumentSignedEditionValuesType[];
  ejemplarPdf: string;
  ejemplarPdf_data: FileCRUDType;
  __ejemplarPdf_files: FileCRUDType[];
  dndaComprobantePdf: string;
  dndaComprobantePdf_data: FileCRUDType;
  __dndaComprobantePdf_files: FileCRUDType[];
  showBlockchainCertificates: SignedEditionBlockchainCertValuesType[];
  dndaUploadLink: string;
  dndaUploadPassword: string;
  dndaUploadPasswordHasValue: boolean;
  dndaUploadKeyReceivedAt: Date | null;
  dndaUploadKeyExpiresAt: Date | null;
  dndaComprobanteReceivedAt: Date | null;
  dndaLastComprobantePollAt: Date | null;
  ejemplarGenerationAttempts: number;
  dndaRegistroAttempts: number;
  dndaUploadAttempts: number;
  dndaLastOperationalError: string;
  sadaicLastPolledAt: Date | null;
  sadaicDeliveredAt: Date | null;
  sadaicUploadAttempts: number;
  sadaicLastOperationalError: string;
  createdAt_: Date | null;
  lastUpdatedAt_: Date | null;
  data_: any;
  originalId_: string;
  name: string;
  editionNumber: number | undefined;
};

export type SignedEditionErrorsType = {
  dndaState?: { message: string; fieldLabel: string };
  sadaicState?: { message: string; fieldLabel: string };
  works?: { message: string; fieldLabel: string };
  publicationDate?: { message: string; fieldLabel: string };
  dndaExpedienteNumber?: { message: string; fieldLabel: string };
  dndaDocuments?: { message: string; fieldLabel: string };
  ejemplarPdf?: { message: string; fieldLabel: string };
  dndaComprobantePdf?: { message: string; fieldLabel: string };
  blockchainCertificates?: { message: string; fieldLabel: string };
  dndaUploadLink?: { message: string; fieldLabel: string };
  dndaUploadPassword?: { message: string; fieldLabel: string };
  dndaUploadKeyReceivedAt?: { message: string; fieldLabel: string };
  dndaUploadKeyExpiresAt?: { message: string; fieldLabel: string };
  dndaComprobanteReceivedAt?: { message: string; fieldLabel: string };
  dndaLastComprobantePollAt?: { message: string; fieldLabel: string };
  ejemplarGenerationAttempts?: { message: string; fieldLabel: string };
  dndaRegistroAttempts?: { message: string; fieldLabel: string };
  dndaUploadAttempts?: { message: string; fieldLabel: string };
  dndaLastOperationalError?: { message: string; fieldLabel: string };
  sadaicLastPolledAt?: { message: string; fieldLabel: string };
  sadaicDeliveredAt?: { message: string; fieldLabel: string };
  sadaicUploadAttempts?: { message: string; fieldLabel: string };
  sadaicLastOperationalError?: { message: string; fieldLabel: string };
  data_?: { message: string; fieldLabel: string };
  originalId_?: { message: string; fieldLabel: string };
  name?: { message: string; fieldLabel: string };
  editionNumber?: { message: string; fieldLabel: string };
};

export function SignedEditionValuesInit(): SignedEditionValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    dndaState_transitions_: [],
    __dndaState: "",
    showDndaState: null,
    sadaicState_transitions_: [],
    __sadaicState: "",
    showSadaicState: null,
    __works: [],
    showWorks: [],
    publicationDate: null,
    dndaExpedienteNumber: "",
    showDndaDocuments: [],
    ejemplarPdf: "",
    ejemplarPdf_data: fileCRUDInit(),
    __ejemplarPdf_files: [],
    dndaComprobantePdf: "",
    dndaComprobantePdf_data: fileCRUDInit(),
    __dndaComprobantePdf_files: [],
    showBlockchainCertificates: [],
    dndaUploadLink: "",
    dndaUploadPassword: "",
    dndaUploadPasswordHasValue: false,
    dndaUploadKeyReceivedAt: null,
    dndaUploadKeyExpiresAt: null,
    dndaComprobanteReceivedAt: null,
    dndaLastComprobantePollAt: null,
    ejemplarGenerationAttempts: 0,
    dndaRegistroAttempts: 0,
    dndaUploadAttempts: 0,
    dndaLastOperationalError: "",
    sadaicLastPolledAt: null,
    sadaicDeliveredAt: null,
    sadaicUploadAttempts: 0,
    sadaicLastOperationalError: "",
    createdAt_: null,
    lastUpdatedAt_: null,
    data_: "{}",
    originalId_: "",
    name: "",
    editionNumber: undefined,
  };
}

export type SignedEditionType = SignedEdition | SignedEditionValuesType;

export function signedEditionDisplayId(
  source: Partial<SignedEdition>,
  _langStore: LangStore
) {
  return (
    (source.data_?.name ?? _langStore.emptyStringSymbol) +
    " #" +
    (source.data_?.editionNumber ?? _langStore.emptyStringSymbol)
  );
}

export function getSignedEditionValues(
  source: SignedEditionType,
  _langStore: LangStore,
  _duplicated: boolean = false
): SignedEditionValuesType {
  const entityValues = SignedEditionValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : signedEditionDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.dndaState_transitions_ = source.dndaState_transitions_;
  entityValues.showDndaState =
    "dndaState" in source && source.dndaState
      ? {
          id: source.dndaState.id,
          displayId: signedEditionDndaWorkflowStateDisplayId(
            source.dndaState,
            _langStore
          ),
        }
      : "showDndaState" in source && source.showDndaState
      ? {
          id: source.showDndaState.id,
          displayId: source.showDndaState.displayId,
        }
      : null;
  entityValues.__dndaState = entityValues.showDndaState?.displayId || "";
  entityValues.sadaicState_transitions_ = source.sadaicState_transitions_;
  entityValues.showSadaicState =
    "sadaicState" in source && source.sadaicState
      ? {
          id: source.sadaicState.id,
          displayId: signedEditionSadaicWorkflowStateDisplayId(
            source.sadaicState,
            _langStore
          ),
        }
      : "showSadaicState" in source && source.showSadaicState
      ? {
          id: source.showSadaicState.id,
          displayId: source.showSadaicState.displayId,
        }
      : null;
  entityValues.__sadaicState = entityValues.showSadaicState?.displayId || "";
  entityValues.showWorks =
    "works" in source && source.works
      ? (source.works || []).map((x) => {
          return { id: x.id, displayId: musicalWorkDisplayId(x, _langStore) };
        })
      : "showWorks" in source && source.showWorks
      ? (source.showWorks || []).map((x) => {
          return { id: x.id, displayId: x.displayId };
        })
      : [];
  entityValues.__works = entityValues.showWorks.map((x) => x.displayId);
  entityValues.publicationDate = diaDeCalendario(source.publicationDate);
  entityValues.dndaExpedienteNumber = source.dndaExpedienteNumber || "";
  entityValues.showDndaDocuments =
    "dndaDocuments" in source && source.dndaDocuments
      ? (source.dndaDocuments || []).map((x) => {
          const row: AssociatedDocumentSignedEditionValuesType =
            getAssociatedDocumentSignedEditionValues(
              x,
              _langStore,
              _duplicated
            );
          return { ...row, __status__: _duplicated ? "added" : "original" };
        })
      : "showDndaDocuments" in source && source.showDndaDocuments
      ? (source.showDndaDocuments || []).map((x) => {
          const row: AssociatedDocumentSignedEditionValuesType =
            getAssociatedDocumentSignedEditionValues(
              x,
              _langStore,
              _duplicated
            );
          // Fila de grilla ya existente: preservar su __status__ (una fila "added"
          // reseteada a "original" se clasifica en update[] con id temporal y sin
          // version_ — el server la rechaza). "original" solo como fallback para
          // filas sin status real (init "empty").
          return {
            ...row,
            __status__: _duplicated
              ? "added"
              : row.__status__ && row.__status__ !== "empty"
              ? row.__status__
              : "original",
          };
        })
      : [];
  entityValues.__ejemplarPdf_files =
    source.ejemplarPdf_data && !_duplicated
      ? [
          {
            id:
              "id" in source.ejemplarPdf_data && source.ejemplarPdf_data.id
                ? source.ejemplarPdf_data.id
                : `generated_${uniqueCounter++}`,
            name: source.ejemplarPdf_data.name,
            description: source.ejemplarPdf_data.description || undefined,
            size: source.ejemplarPdf_data.size || 0,
            formattedSize: source.ejemplarPdf_data.size
              ? formatBytes(source.ejemplarPdf_data.size)
              : "",
            mimetype: source.ejemplarPdf_data.mimetype,
            url: source.ejemplarPdf_data.url || undefined,
            __status__: "original",
          },
        ]
      : [];
  entityValues.ejemplarPdf =
    source.ejemplarPdf && !_duplicated ? source.ejemplarPdf : "";
  entityValues.ejemplarPdf_data =
    source.ejemplarPdf_data && "__status__" in source.ejemplarPdf_data
      ? source.ejemplarPdf_data
      : source.ejemplarPdf_data
      ? {
          id: ("id" in source.ejemplarPdf_data && source.ejemplarPdf_data.id
            ? source.ejemplarPdf_data.id
            : `generated_${uniqueCounter++}`) as string,
          name: source.ejemplarPdf_data.name,
          description: source.ejemplarPdf_data.description || undefined,
          size: source.ejemplarPdf_data.size || 0,
          formattedSize: source.ejemplarPdf_data.size
            ? formatBytes(source.ejemplarPdf_data.size)
            : "",
          mimetype: source.ejemplarPdf_data.mimetype,
          url: source.ejemplarPdf_data.url || undefined,
          __status__: "original" as RowCrudStatus,
        }
      : fileCRUDInit();
  entityValues.__dndaComprobantePdf_files =
    source.dndaComprobantePdf_data && !_duplicated
      ? [
          {
            id:
              "id" in source.dndaComprobantePdf_data &&
              source.dndaComprobantePdf_data.id
                ? source.dndaComprobantePdf_data.id
                : `generated_${uniqueCounter++}`,
            name: source.dndaComprobantePdf_data.name,
            description:
              source.dndaComprobantePdf_data.description || undefined,
            size: source.dndaComprobantePdf_data.size || 0,
            formattedSize: source.dndaComprobantePdf_data.size
              ? formatBytes(source.dndaComprobantePdf_data.size)
              : "",
            mimetype: source.dndaComprobantePdf_data.mimetype,
            url: source.dndaComprobantePdf_data.url || undefined,
            __status__: "original",
          },
        ]
      : [];
  entityValues.dndaComprobantePdf =
    source.dndaComprobantePdf && !_duplicated ? source.dndaComprobantePdf : "";
  entityValues.dndaComprobantePdf_data =
    source.dndaComprobantePdf_data &&
    "__status__" in source.dndaComprobantePdf_data
      ? source.dndaComprobantePdf_data
      : source.dndaComprobantePdf_data
      ? {
          id: ("id" in source.dndaComprobantePdf_data &&
          source.dndaComprobantePdf_data.id
            ? source.dndaComprobantePdf_data.id
            : `generated_${uniqueCounter++}`) as string,
          name: source.dndaComprobantePdf_data.name,
          description: source.dndaComprobantePdf_data.description || undefined,
          size: source.dndaComprobantePdf_data.size || 0,
          formattedSize: source.dndaComprobantePdf_data.size
            ? formatBytes(source.dndaComprobantePdf_data.size)
            : "",
          mimetype: source.dndaComprobantePdf_data.mimetype,
          url: source.dndaComprobantePdf_data.url || undefined,
          __status__: "original" as RowCrudStatus,
        }
      : fileCRUDInit();
  entityValues.showBlockchainCertificates =
    "blockchainCertificates" in source && source.blockchainCertificates
      ? (source.blockchainCertificates || []).map((x) => {
          const row: SignedEditionBlockchainCertValuesType =
            getSignedEditionBlockchainCertValues(x, _langStore, _duplicated);
          return { ...row, __status__: _duplicated ? "added" : "original" };
        })
      : "showBlockchainCertificates" in source &&
        source.showBlockchainCertificates
      ? (source.showBlockchainCertificates || []).map((x) => {
          const row: SignedEditionBlockchainCertValuesType =
            getSignedEditionBlockchainCertValues(x, _langStore, _duplicated);
          // Fila de grilla ya existente: preservar su __status__ (una fila "added"
          // reseteada a "original" se clasifica en update[] con id temporal y sin
          // version_ — el server la rechaza). "original" solo como fallback para
          // filas sin status real (init "empty").
          return {
            ...row,
            __status__: _duplicated
              ? "added"
              : row.__status__ && row.__status__ !== "empty"
              ? row.__status__
              : "original",
          };
        })
      : [];
  entityValues.dndaUploadLink = source.dndaUploadLink || "";
  entityValues.dndaUploadPassword = "";
  entityValues.dndaUploadPasswordHasValue = !!source.dndaUploadPasswordHasValue;
  entityValues.dndaUploadKeyReceivedAt = source.dndaUploadKeyReceivedAt
    ? new Date(source.dndaUploadKeyReceivedAt)
    : null;
  entityValues.dndaUploadKeyExpiresAt = source.dndaUploadKeyExpiresAt
    ? new Date(source.dndaUploadKeyExpiresAt)
    : null;
  entityValues.dndaComprobanteReceivedAt = source.dndaComprobanteReceivedAt
    ? new Date(source.dndaComprobanteReceivedAt)
    : null;
  entityValues.dndaLastComprobantePollAt = source.dndaLastComprobantePollAt
    ? new Date(source.dndaLastComprobantePollAt)
    : null;
  entityValues.ejemplarGenerationAttempts =
    source.ejemplarGenerationAttempts || 0;
  entityValues.dndaRegistroAttempts = source.dndaRegistroAttempts || 0;
  entityValues.dndaUploadAttempts = source.dndaUploadAttempts || 0;
  entityValues.dndaLastOperationalError = source.dndaLastOperationalError || "";
  entityValues.sadaicLastPolledAt = source.sadaicLastPolledAt
    ? new Date(source.sadaicLastPolledAt)
    : null;
  entityValues.sadaicDeliveredAt = source.sadaicDeliveredAt
    ? new Date(source.sadaicDeliveredAt)
    : null;
  entityValues.sadaicUploadAttempts = source.sadaicUploadAttempts || 0;
  entityValues.sadaicLastOperationalError =
    source.sadaicLastOperationalError || "";
  entityValues.createdAt_ = source.createdAt_
    ? new Date(source.createdAt_)
    : null;
  entityValues.lastUpdatedAt_ = source.lastUpdatedAt_
    ? new Date(source.lastUpdatedAt_)
    : null;
  entityValues.data_ = source.data_;
  entityValues.originalId_ = source.originalId_;
  entityValues.name = source.name || "";
  entityValues.editionNumber =
    (source.editionNumber as unknown) === "" ||
    source.editionNumber === undefined ||
    source.editionNumber === null
      ? undefined
      : source.editionNumber;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
